export enum ReportingStatus {
  Sufficient = 'Sufficient',
  Low = 'Low',
  Negative = 'Negative',
}
